import React, { FC } from 'react'
import ProductSuggestionsShowcase from './ProductSuggestionsShowcaseContainer'
import { SuggestionTypes } from './typings'

const ProductSuggestions: FC = () => {
  return (
    <>
      {/* // TODO: this error popped up when moving the checkout-instore project
      // to checkout-instore-legacy, but needs to be fixed at some point
      // @ts-ignore */}
      <ProductSuggestionsShowcase
        suggestionType={SuggestionTypes.BestSellers}
      />
    </>
  )
}

export default ProductSuggestions
